import TabulatorOnRowClickAction from "@root/enums/TabulatorOnRowClickAction";
import filterMainTable from "@root/tabulator/onRowClickActions/filterMainTable";

export default function (name) {
  return {
    [TabulatorOnRowClickAction.FILTER_MAIN_TABLE.enumKey]: filterMainTable,
  }[name.toUpperCase()] || null;

}
